<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage krdsView"
    ref="krdsView"
  >
    <header-area />

    <div class="contsLayout topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contentsWrap">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan">
              <span class="pcLine"
                ><em class="mobLine">대한민국 </em
                ><em class="mobLine">디지털 정부서비스의 </em></span
              >
              <span class="pcLine"
                ><em class="mobLine">사용자경험(UIUX)의 </em
                ><em class="mobLine">표준을 수립!</em></span
              >
            </div>
            <div class="workTopDay">
              <p>범정부 UI/UX 공통가이드 개발 및 적용</p>
              <ul>
                <li></li>
                <li>2024.03.01</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <!-- <span class="workMoveTxt">
            <marquee-text :duration="15">&nbsp;Create and customize your own AI for yourself&nbsp;</marquee-text>
          </span>-->
          <img class="web" src="@/assets/images/works_view/krds/visual.png" alt="" />
          <img class="mobile" src="@/assets/images/works_view/krds/visual_m.png" alt="" />
        </div>
      </div>

      <div class="contentsWrap">
        <div class="topInfo">
          <span class="pcLine"
            >범정부UIUX공통가이드 개발 사업은 공공 디지털 서비스의 사용자 경험(UI/UX)을 혁신하여
          </span>
          <span class="pcLine"
            >국민이 공공서비스를 더 쉽고 편리하게 이용할 수 있도록 하는 것입니다.</span
          >
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <section class="contsLayout about">
          <div class="contentsWrap">
            <p
              class="smallTit"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <span class="line">About Project</span>
            </p>
            <div
              class="imgWrap aniOp people"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/about_01.png" alt="" />
              <img class="mobile" src="@/assets/images/works_view/krds/about_01_m.png" alt="" />
            </div>
            <div
              class="imgWrap aniOp gov"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/about_02.png" alt="" />
              <img class="mobile" src="@/assets/images/works_view/krds/about_02_m.png" alt="" />
            </div>
          </div>
        </section>

        <section class="process">
          <div class="contsLayout contentsWrap">
            <p
              class="smallTit"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <span class="line">Work Process</span>
            </p>
            <p
              class="subTxt aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <span class="pcLine">공공서비스 사용자들의 데이터 및 요구사항 분석을 기반으로 </span>
              <span class="pcLine">사용자 중심의 UI/UX 공통가이드를 구현 했습니다.</span>
            </p>
          </div>
          <div
            class="imgWrap aniOp"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <img class="web" src="@/assets/images/works_view/krds/process_01.png" alt="" />
            <img class="mobile" src="@/assets/images/works_view/krds/process_01_m.png" alt="" />
          </div>
        </section>

        <section class="analysis">
          <div class="contsLayout contentsWrap">
            <p
              class="smallTit"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <span class="line">Analysis</span>
            </p>
          </div>
          <div class="conts conts01">
            <div class="contsLayout contentsWrap ">
              <p
                class="subTit aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                사용자 분석
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >실제 이용 상황에서 사용자 의견과 일반적인 사용성에 대한 전문가 의견을
                </span>
                <span class="pcLine">종합적으로 분석하여 핵심 UI/UX 문제점을 도출하였습니다.</span>
              </p>
            </div>
            <div
              class="imgWrap aniOp align right"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/analysis_01.png" alt="" />
              <img class="mobile" src="@/assets/images/works_view/krds/analysis_01_m.png" alt="" />
            </div>
          </div>
          <div class="conts conts02">
            <div class="contsLayout contentsWrap">
              <p
                class="subTit aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                글로벌 국가의 디자인 시스템 분석
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >글로벌 디지털 정부 가이드의 특성과 민간 서비스 디자인시스템의 동향을 종합적으로
                  분석하여
                </span>
                <span class="pcLine"
                  >정부 아이덴티티 영역 적용 기준을 정의하고, 공통 가이드 개발 범위를
                  도출하였습니다.</span
                >
              </p>
            </div>
            <div
              class="contsLayout contentsWrap imgWrap aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/analysis_02_01.png" alt="" />
              <img
                class="mobile"
                src="@/assets/images/works_view/krds/analysis_02_01_m.png"
                alt=""
              />
            </div>
            <div
              class="imgWrap aniOp align right"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/analysis_02_02.png" alt="" />
              <img
                class="mobile"
                src="@/assets/images/works_view/krds/analysis_02_02_m.png"
                alt=""
              />
            </div>
          </div>
          <div class="conts conts03">
            <div class="contsLayout contentsWrap">
              <p
                class="subTit aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                국민 평가단 만족도 조사
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >다양한 연령 및 성별 그리고 디지털 취약계층을 포함한 300명의 국민평가단을 모집하여
                </span>
                <span class="pcLine">300개의 공공기관의 UIUX 만족도 평가를 진행했습니다.</span>
              </p>
            </div>
            <div class="contsLayout contentsWrap">
              <ul class="satisfy">
                <li
                  class="aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="imgWrap">
                    <img
                      class="web"
                      src="@/assets/images/works_view/krds/analysis_03_01.png"
                      alt=""
                    />
                    <img
                      class="mobile"
                      src="@/assets/images/works_view/krds/analysis_03_01_m.png"
                      alt=""
                    />
                  </div>
                </li>
                <li
                  class="aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="imgWrap">
                    <img
                      class="web"
                      src="@/assets/images/works_view/krds/analysis_03_02.png"
                      alt=""
                    />
                    <img
                      class="mobile"
                      src="@/assets/images/works_view/krds/analysis_03_02_m.png"
                      alt=""
                    />
                  </div>
                </li>
                <li
                  class="aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="imgWrap">
                    <img
                      class="web"
                      src="@/assets/images/works_view/krds/analysis_03_03.png"
                      alt=""
                    />
                    <img
                      class="mobile"
                      src="@/assets/images/works_view/krds/analysis_03_03_m.png"
                      alt=""
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section class="guide">
          <div class="contsLayout contentsWrap">
            <p
              class="smallTit"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <span class="line">Developing a Guide</span>
            </p>
          </div>
          <div
            class="imgWrap aniOp align center wide"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <img class="web" src="@/assets/images/works_view/krds/guide_common_01.png" alt="" />
            <img
              class="mobile"
              src="@/assets/images/works_view/krds/guide_common_01_m.png"
              alt=""
            />
          </div>

          <div class="conts conts01">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">UI/UX 설계 원칙</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                누구나 더 쉽고 편리한 디지털플랫폼 정부 서비스를 목표로 총 7가지의 디자인원칙을
                수립했습니다. <br />
                UI/UX 설계 원칙의 중요한 이유와 의미를 설명하고 이를 따르기 위한 주요 방안을
                제시합니다.
              </p>
            </div>
            <div
              class="imgWrap aniOp align right"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/guide_01_01.png" alt="" />
              <img class="mobile" src="@/assets/images/works_view/krds/guide_01_01_m.png" alt="" />
            </div>
          </div>
          <div class="conts conts02">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">스타일 가이드</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >일관성과 유연성 확보의 관점으로 사용자에게 가장 효과적으로 인지될 수 있는
                </span>
                <span class="pcLine"
                  >칼라, 폰트, 레이아웃과그리드, 형태, 아이콘등 총 5가지 스타일요소를 선정하여
                </span>
                <span class="pcLing">디지털 정부서비스의 디자인 스타일를 수립하였습니다.</span>
              </p>
            </div>
            <!-- swiper -->
            <div
              class="guideSlider swiper-container contsLayout aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="imgWrap default">
                    <img src="@/assets/images/works_view/krds/style_swiper_01.png" alt="" />
                  </div>
                  <div class="imgWrap active">
                    <img src="@/assets/images/works_view/krds/style_swiper_01_active.png" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="imgWrap default">
                    <img src="@/assets/images/works_view/krds/style_swiper_02.png" alt="" />
                  </div>
                  <div class="imgWrap active">
                    <img src="@/assets/images/works_view/krds/style_swiper_02_active.png" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="imgWrap default">
                    <img src="@/assets/images/works_view/krds/style_swiper_03.png" alt="" />
                  </div>
                  <div class="imgWrap active">
                    <img src="@/assets/images/works_view/krds/style_swiper_03_active.png" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="imgWrap default">
                    <img src="@/assets/images/works_view/krds/style_swiper_04.png" alt="" />
                  </div>
                  <div class="imgWrap active">
                    <img src="@/assets/images/works_view/krds/style_swiper_04_active.png" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="imgWrap default">
                    <img src="@/assets/images/works_view/krds/style_swiper_05.png" alt="" />
                  </div>
                  <div class="imgWrap active">
                    <img src="@/assets/images/works_view/krds/style_swiper_05_active.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <!-- //swiper -->
          </div>
          <div class="conts conts03">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">컴포넌트</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >정부서비스 보편적인 UI요소를 방향으로 가장 빈번하게 사용되는
                </span>
                <span class="pcLine">공통 구성요소를 선정하여 37가지 컴포넌트를 개발했습니다.</span>
              </p>
            </div>
            <div class="componentImgWrap">
              <!-- 중심 이미지 -->
              <div
                class="imgWrap aniOp align center wide"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="web">
                  <img src="@/assets/images/works_view/krds/component_bg.png" alt="" />
                </div>
                <div class="mobile">
                  <img src="@/assets/images/works_view/krds/component_bg_m.png" alt="" />
                </div>
              </div>
              <!-- //중심 이미지 -->
              <!-- 왼쪽 -->
              <div class="contsWrap leftSide">
                <!-- 화살표 -->
                <div
                  class="imgWrap aniOp arrow"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="web">
                    <img src="@/assets/images/works_view/krds/component_line_01.png" alt="" />
                  </div>
                </div>
                <!-- //화살표 -->
                <!-- 내용 -->
                <div
                  class="imgWrap aniOp contents"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="web">
                    <img src="@/assets/images/works_view/krds/component_conts_01.png" alt="" />
                  </div>
                  <div class="mobile">
                    <img src="@/assets/images/works_view/krds/component_conts_01_m.png" alt="" />
                  </div>
                </div>
                <!-- //내용 -->
              </div>
              <!-- //왼쪽 -->
              <!-- 오른쪽 -->
              <div class="contsWrap rightSide">
                <!-- 화살표 -->
                <div
                  class="imgWrap aniOp arrow"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="web">
                    <img src="@/assets/images/works_view/krds/component_line_02.png" alt="" />
                  </div>
                </div>
                <!-- //화살표 -->
                <!-- 내용 -->
                <div
                  class="imgWrap aniOp contents"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="web">
                    <img src="@/assets/images/works_view/krds/component_conts_02.png" alt="" />
                  </div>
                  <div class="mobile">
                    <img src="@/assets/images/works_view/krds/component_conts_02_m.png" alt="" />
                  </div>
                </div>
                <!-- //내용 -->
              </div>
              <!-- //오른쪽 -->
            </div>
            <div
              class="imgWrap aniOp align center wide full"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="web">
                <img src="@/assets/images/works_view/krds/component_02.png" alt="" />
              </div>
              <div class="mobile">
                <img src="@/assets/images/works_view/krds/component_02_m.png" alt="" />
              </div>
            </div>
          </div>
          <div class="conts conts04">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">기본 패턴</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >디지털공공서비스의 핵심과업에서 공통으로 사용되는 11가지 과업 패턴을
                </span>
                <span class="pcLine"
                  >기본 패턴으로 선정하여 구조 및 사용자 상호작용에 대한 가이드를 제시
                  했습니다.</span
                >
              </p>
              <div
                class="tagWrap aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <ul>
                  <li>도움</li>
                  <li>목록 탐색</li>
                  <li>필터링/정렬</li>
                  <li>상세 정보 확인</li>
                  <li>동의</li>
                  <li>사용자 피드백</li>
                  <li>개인 식별 정보 입력</li>
                  <li>첨부파일</li>
                  <li>입력 폼</li>
                  <li>확인</li>
                  <li>오류</li>
                </ul>
              </div>
            </div>
            <ul class="patternType">
              <li class="order">
                <div
                  class="descWrap aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <p class="tit">필터링·정렬</p>
                  <p class="desc">
                    필터링과 정렬은 사용자가 데이터를 원하는 기준에 맞게 선택하고 조직화 할 수 있게
                    합니다. 이를 통해 검색 결과를 좁히고 원하는 정보를 빠르게 찾을 수 있습니다.
                  </p>
                </div>
                <div
                  class="imgWrap aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <img
                    class="web"
                    src="@/assets/images/works_view/krds/default_pattern_01.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/krds/default_pattern_01_m.png"
                    alt=""
                  />
                </div>
              </li>
              <li class="help">
                <div
                  class="descWrap"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <p class="tit">도움</p>
                  <p class="desc">
                    사용자를 위한 도움 패턴은 서비스 이용 도중 UI 작동 방식, 사용법, 과업 진행 상황
                    등을 설명하는데 도움을 줍니다. 이는 특히 디지털 취약계층 사용자에게 더 쉽고
                    빠르게 서비스를 이해하고 활용할 수 있도록 해줍니다.
                  </p>
                </div>
                <div
                  class="imgWrap aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <img
                    class="web"
                    src="@/assets/images/works_view/krds/default_pattern_02.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/krds/default_pattern_02_m.png"
                    alt=""
                  />
                </div>
              </li>
              <li class="feedback">
                <div
                  class="descWrap"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <p class="tit">사용자 피드백</p>
                  <p class="desc">
                    사용자가 원하는 정보를 명확하고 간결하게 제공할 수 있도록 합니다. 또한 제목과
                    요약 정보를 포함한 링크를 통해 사용자가 쉽게 상세 정보에 접근할 수 있도록 가이드
                    합니다.
                  </p>
                </div>
                <div
                  class="imgWrap aniOp"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <img
                    class="web"
                    src="@/assets/images/works_view/krds/default_pattern_03.png"
                    alt=""
                  />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/krds/default_pattern_03_m.png"
                    alt=""
                  />
                </div>
              </li>
            </ul>
          </div>
          <div class="conts conts05">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">서비스 패턴 가이드</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >핵심서비스의 사용자 여정을 기반으로 사용자경험 설계를 위한 서비스 패턴 제작하고
                </span>
                <span class="pcLine"
                  >서비스 특성을 고려하여 최적화 할 수 있도록 다양한 유형을 제공합니다.</span
                >
              </p>
              <div
                class="tagWrap colored aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <ul>
                  <li>방문</li>
                  <li>검색</li>
                  <li>로그인</li>
                  <li>신청</li>
                  <li>정책 정보 확인</li>
                </ul>
              </div>
            </div>

            <div
              class="imgWrap serviceImg01 aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img
                class="web"
                src="@/assets/images/works_view/krds/service_pattern_01.png"
                alt=""
              />
              <img
                class="mobile"
                src="@/assets/images/works_view/krds/service_pattern_01_m.png"
                alt=""
              />
            </div>
            <div
              class="imgWrap serviceImg02 aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img
                class="web"
                src="@/assets/images/works_view/krds/service_pattern_02.png"
                alt=""
              />
              <img
                class="mobile"
                src="@/assets/images/works_view/krds/service_pattern_02_m.png"
                alt=""
              />
            </div>
          </div>
          <div class="conts conts06">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">디자인 리소스 및 표준 HTML 코드 개발</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="pcLine"
                  >만들어진 가이드를 Figma기반의 디자인 리소스와 표준 HTML로 개발하여
                </span>
                <span class="pcLine"
                  >디자이너와 개발자들이 쉽게 이해하고 사용할 수 있도록 개발되었습니다.</span
                >
              </p>
              <div
                class="tagWrap colored aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <ul>
                  <li>피그마</li>
                  <li>컴포넌트</li>
                  <li>패턴</li>
                  <li>코드</li>
                  <li>웹 페이지 가이드</li>
                </ul>
              </div>
            </div>
            <ul class="resourceList">
              <li v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
                <div class="imgWrap">
                  <img class="web" src="@/assets/images/works_view/krds/resource_01.png" alt="" />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/krds/resource_01_m.png"
                    alt=""
                  />
                </div>
                <div class="descWrap">
                  <p class="tit">디자인 리소스</p>
                  <p class="desc">
                    디자인툴중 가장 사용율이 높은 Figma를 기반으로 쉽게 재 사용 할 수 있는
                    라이브러리와 패턴을 제공합니다.
                  </p>
                </div>
              </li>
              <li v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
                <div class="imgWrap">
                  <img class="web" src="@/assets/images/works_view/krds/resource_02.png" alt="" />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/krds/resource_02_m.png"
                    alt=""
                  />
                </div>
                <div class="descWrap">
                  <p class="tit">표준 마크업</p>
                  <p class="desc">
                    개발자들이 쉽게 이해하고 활용할 수 있도록 각 컴포넌트와 패턴 디자인에 상호작용을
                    적용한 HTML표준 마크업을 제공합니다.
                  </p>
                </div>
              </li>
              <li v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
                <div class="imgWrap">
                  <img class="web" src="@/assets/images/works_view/krds/resource_03.png" alt="" />
                  <img
                    class="mobile"
                    src="@/assets/images/works_view/krds/resource_03_m.png"
                    alt=""
                  />
                </div>
                <div class="descWrap">
                  <p class="tit">웹 페이지 가이드</p>
                  <p class="desc">
                    문서형태의 한계를 극복하기 위해 좁더 빠르게 편리하게 탐색하고 체험할 수 있는
                    공통가이드 웹페이지를 제공합니다.
                  </p>
                </div>
              </li>
            </ul>
            <div
              class="imgWrap resouece02 aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/resource_04.png" alt="" />
              <img class="mobile" src="@/assets/images/works_view/krds/resource_04_m.png" alt="" />
            </div>
          </div>

          <div class="conts conts07">
            <div class="contsLayout contentsWrap">
              <p
                class="smallTit sub"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="line">범정부 공통 가이드는</span>
              </p>
              <p
                class="subTxt aniOp"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <span class="mobLine">
                  <span class="pcLine"
                    >모든 사용자를 포용하고 사용자 경험을 개선하는 것은 물론이고
                  </span>
                  <span class="pcLine">각 기관들의 효율적인 운영/관리를 위해 제작되었습니다.</span>
                </span>
                <span class="mobLine">
                  <span class="pcLine">이를 통해 정부 서비스의 품질을 향상 시키고, </span>
                  <span class="pcLine"
                    >국민들에게 더 나은 디지털 경험을 제공할 수 있을 것입니다.</span
                  >
                </span>
              </p>
            </div>
            <div
              class="imgWrap aniOp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img class="web" src="@/assets/images/works_view/krds/common_guide_01.png" alt="" />
              <img
                class="mobile"
                src="@/assets/images/works_view/krds/common_guide_01_m.png"
                alt=""
              />
            </div>
          </div>
        </section>
      </div>
    </kinesis-container>

    <div class="viewLayout">
      <div class="contentsWrap">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-maumAI' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">마음AI 플랫폼 이노베이션</strong>
          <strong class="mobile"
            >마음AI<br />
            플랫폼 이노베이션</strong
          >
        </div>

        <div class="engBg krds">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import "@/assets/css/workKrds.scss";

// import {
//   TweenLite
// } from "gsap/all";

Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Krds",
  /* head: {
    title: {
      inner: '범정부 UI/UX 공통가이드 개발 및 적용'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },

    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      //W: 0,
      icoInter: null,
      icoVal: 0,
      scrollTop: 0,
      throttle: 100,
      meta: {
        title: "범정부 UI/UX 공통가이드",
        siteName: "범정부 UI/UX 공통가이드 | 플립커뮤니케이션즈",
        desc:
          "대한민국 정부 디지털 서비스의 사용자 경험(UI/UX) 표준을 위해 범정부 UI/UX 공통가이드를 개발하여 국민들이 더욱 쉽고 편리하게 공공서비스를 이용할 수 있도록 지원합니다. 사용자 데이터 분석을 기반으로 7가지 UI/UX 설계 원칙을 정립하고 37가지 주요 컴포넌트 및 11가지 기본 패턴 등을 제공합니다.",
        keywords:
          "범정부 UI/UX 공통가이드, 공공 디지털 서비스, 사용자 경험 개선, 정부 서비스 품질 향상, 사용자 중심 디자인, UI/UX 공통 원칙, 사용자 데이터 분석, 디지털 정부 서비스, 국민 만족도 조사, 글로벌 디자인 시스템, 디지털 서비스 스타일 가이드, UI 컴포넌트 개발, 공공기관 UI/UX 평가, 디지털 서비스 표준 마크업, Figma 디자인 리소스",
        url: "https://www.pulip.com/works/Krds",
        img: "https://www.pulip.com/pulip-logo.jpg"
      }
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    })
    /*W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }*/
  },
  methods: {
    // vuejs Bicint
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/maum").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    observeActive2(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add("active");
      }
    },

    handleScroll: function(e) {
      // this.scrollTop = e.target.scrollTop;
      console.log("scroll :", e.target.scrollTop);
    },
    observeTit(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add("active");
        setTimeout(() => {
          this.$refs.titWrap.style.position = "fixed";
        }, 200);
      } else {
        entry.target.classList.remove("active");
        setTimeout(() => {
          this.$refs.titWrap.style.position = "sticky";
        }, 200);

        //console.log('else');
      }
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", () => {
      console.log("in created");
    });
    this.handleResize();
  },
  beforeDestroy() {
    try {
      this.guideSlider.destroy();
      clearInterval(this.icoInter);
    } catch (err) {}
  },
  mounted() {
    this.guideSlider = new window.Swiper(".guideSlider.swiper-container", {
      observer: true,
      observeParents: true,
      loopAdditionalSlides: 1,
      observeSlideChildren: true,
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 24,
      speed: 1000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      },
      breakpoints: {
        891: {
          spaceBetween: 40
        }
      }
    });
  },
  beforeUnmount() {
    this.target.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
